export const formatearFicha = (valor) => {
  if (valor === null || valor === undefined) return "";
  if (typeof valor === "object") {
    try {
      return JSON.stringify(valor, null, 2);
    } catch (e) {
      return String(valor);
    }
  }
  return String(valor);
};

export const construirPayload = ({
  empresa,
  tipo,
  descripcion,
  metraje,
  perfil,
  ficha,
  idSubproducto,
}) => {
  const subproducto = {
    idEmpresa: empresa,
    idTipo: tipo,
    descripcion: descripcion.trim(),
    metraje: metraje,
  };
  if (idSubproducto) {
    subproducto.id = idSubproducto;
  }
  const payload = { subproducto };
  if (perfil && ficha) {
    payload.ficha = {
      perfil: perfil.trim(),
      ficha: ficha,
    };
  }
  return payload;
};
